/**
 * @generated SignedSource<<0928bc41f089ca818a3aeea550a5a50a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksPaywallPromiseContent$data = {
  readonly entityId: string;
  readonly " $fragmentType": "hooksPaywallPromiseContent";
};
export type hooksPaywallPromiseContent$key = {
  readonly " $data"?: hooksPaywallPromiseContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksPaywallPromiseContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksPaywallPromiseContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "8b15ed0912437a4f9ba75f1917967e6f";

export default node;
